<template>
  <v-list-item-avatar class="mx-0" :size="size">
    <v-avatar v-if="this.src" :size="size" :color="this.color">
      <v-img :size="size" :src="this.src"></v-img>
    </v-avatar>
    <v-avatar :size="size" v-else :color="this.src ? this.color : 'grey'">
      <span
        v-text="getMyInitials"
        :class="[this.color, 'fullwidth', 'v-avatar', 'white--text', 'text-h5']"
      >
      </span>
    </v-avatar>
  </v-list-item-avatar>
</template>

<script>
//import firebase from 'firebase'
import { getInitials } from '../../helpers/functions'

export default {
  name: 'Avatar',
  props: {
    size: {
      type: [Number, String],
      default: 40
    },
    src: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'primary'
    },
    displayName: {
      type: String,
      default: ''
    }
  },

  computed: {
    getMyInitials() {
      return this.displayName ? getInitials(this.displayName) : ''
    },
    avatarColor() {
      return this.src ? this.color : 'grey'
    }
  },
  data: () => ({
    email: null
  }),
  watch: {
    // Remove the watch since we're not updating properties anymore
  }
}
</script>

<style lang="scss" scoped>
.fullwidth {
  width: inherit;
  height: inherit;
}
</style>
